import { render, staticRenderFns } from "./feePermissions.vue?vue&type=template&id=1f6875a2"
import script from "./feePermissions.vue?vue&type=script&lang=js"
export * from "./feePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports